<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right" *ngIf="!showSearch">
        <div class="ir-btn th-btn-modal" (click)="updateShowSearch()">
          <i class="material-icons">search</i>
        </div>
      </div>
      <div class="ir-line" *ngIf="!showSearch">
        <div class="ir-line-content">
          <span *ngIf="model"
            >{{ 'inspections.select-module-from' | translate }} <strong>({{ model.name }})</strong></span
          >
        </div>
      </div>
      <div class="ir-line th-header-search" *ngIf="showSearch">
        <div class="ir-line--left">
          <div class="ir-btn th-btn-unactive">
            <i class="material-icons">search</i>
          </div>
        </div>
        <div class="ir-line--right">
          <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
            <i class="material-icons">close</i>
          </div>
        </div>
        <div class="ir-line-content">
          <input
            autoFocus
            type="search"
            name="Search"
            placeholder="{{ 'common.placeholders.search' | translate }}"
            [(ngModel)]="query"
            focus="showSearch"
          />
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer">
      <div class="ir-content--modal th-content">
        <span *ngIf="loading">{{ 'common.loading' | translate }}...</span>
        <model-sections
          [inspection]="model"
          (toggleSelectSection)="selectInspectionSection($event)"
          [query]="query"
        ></model-sections>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.back' | translate }}</span>
          </div>
        </div>

        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            (click)="openSection()"
            *ngIf="selectedSection"
          >
            <span>{{ 'inspections.open' | translate }} &laquo; {{ selectedSection.name }} &raquo;</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" *ngIf="!selectedSection">
            <span>{{ 'inspections.select-section' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
